import { useState, useEffect } from 'react';
import { getSelectClientes } from '../../../service/clientes/Clientes';
import { ClienteModel } from '../models/EstudiantesModel';
import { useHistory } from 'react-router-dom';
import { getAllEstudiantes } from '../../../service/estudiantes/Estudiantes';

export const useGetAll = (filters: any) => {
  const [data, setData] = useState<ClienteModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(0);

  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getAllEstudiantes(filters)
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setData(res.rows);
        setLoadingRequest(1);
      }
    };
    fetchPost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);
  return { data, loadingRequest };
};

export const useSelectClients = (show: boolean) => {
  const [data, setData] = useState<ClienteModel[]>([]);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getSelectClientes()
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setData(res);
      }
    };
    if (show) {
      fetchPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return { data };
};
